import React from 'react'
import { Input } from '../../Form'
import { getMessage } from '../../../lib/translator'
import searchIcon from '../../OmniChallenge/icon-search.svg'
import crossIcon from '../../Form/cross_gray.svg'
import { handleErrors } from '../../OmniChallenge/utils'
import API from '../../../lib/api'
import { getCouponTemplateDetails } from './couponTemplate'

export const getOfferDetails = async (offerId) => {
  try {
    const offerAPI = new API({ url: `/offer-service/offer/${offerId}` })
    const response = await offerAPI.get()

    if (!response) {
      throw new Error('No response received')
    }

    const { description = '' } = response.data?.offers ?? {}

    return {
      description,
      offerError: '',
    }
  } catch (error) {
    return {
      description: '',
      offerError: handleErrors(error, offerId),
    }
  }
}

const COLUMN_STYLE = { alignSelf: 'flex-start' }

const ValueChip = ({ text, onClear, clearLabel }) =>
  text ? (
    <div className="offer-select-value">
      <small>{text}</small>
      <button
        type="button"
        className="offer-select-value-icon"
        onClick={onClear}
        aria-label={clearLabel}
      >
        <img src={crossIcon} alt="" />
      </button>
    </div>
  ) : null

const OfferField = ({ _this }) => {
  const { values } = _this.state
  const { metadata, type } = values ?? {}

  const isTypeFPGProduct = type === 'FPG_PRODUCT_VOUCHER'
  const atLeastOneError = getMessage('rewards.catalogue.product.atLeastOne')

  const setProductFields = (fields) => {
    _this.setState({
      values: {
        ...values,
        metadata: {
          ...values.metadata,
          product: {
            ...values.metadata?.product,
            ...fields,
          },
        },
      },
    })
  }

  const handleSearch = async (e, id) => {
    e.preventDefault()
    if (!id) {
      return
    }

    const details = await getOfferDetails(id)
    setProductFields({
      description: details.description,
      offerError: details.offerError,
      offerId: details.offerError ? '' : id,
    })
  }

  const handleCouponSearch = async (e, code) => {
    e.preventDefault()
    if (!code) {
      return
    }

    const details = await getCouponTemplateDetails(code)
    setProductFields({
      couponTitle: details.couponTitle,
      couponError: details.couponError,
      // the "enter at least one" error is stored on offerError; a valid coupon answers it
      ...(!details.couponError &&
        offerError === atLeastOneError && { offerError: '' }),
    })
  }

  const handleOfferClear = () =>
    setProductFields({ offerId: '', description: '', offerError: '' })

  const handleCouponClear = () =>
    setProductFields({ dspTemplateCode: '', couponTitle: '', couponError: '' })

  const {
    description = '',
    offerId = '',
    offerError = '',
    dspTemplateCode = '',
    couponTitle = '',
    couponError = '',
  } = metadata?.product ?? {}

  if (!isTypeFPGProduct) {
    return <div className="hideInputField" />
  }

  const offerIdLabel = getMessage('rewards.catalogue.offerId')
  const couponCodeLabel = getMessage('rewards.catalogue.dspTemplateCode')
  const removeOfferLabel = getMessage('rewards.catalogue.removeOfferId')
  const removeCouponLabel = getMessage(
    'rewards.catalogue.removeDspTemplateCode'
  )

  return (
    <>
      <div className="col-6" style={COLUMN_STYLE}>
        <Input
          name={`select-offerid`}
          label={offerIdLabel}
          placeholder={offerIdLabel}
          type="text"
          value={offerId}
          {..._this.generateStateMappers({
            stateKeys: ['metadata', 'product', 'offerId'],
          })}
          secondaryAction={{
            name: <img key="search" src={searchIcon} alt={`select-offerid`} />,
            onAction: (e) => {
              handleSearch(e, offerId)
            },
          }}
        />
        <ValueChip
          text={description}
          onClear={handleOfferClear}
          clearLabel={removeOfferLabel}
        />
        {offerError && <div className="error">{offerError}</div>}
      </div>
      <div className="col-6" style={COLUMN_STYLE}>
        <Input
          name="coupon-template-code"
          label={couponCodeLabel}
          placeholder={couponCodeLabel}
          type="text"
          maxLength={50}
          value={dspTemplateCode}
          {..._this.generateStateMappers({
            stateKeys: ['metadata', 'product', 'dspTemplateCode'],
          })}
          secondaryAction={{
            name: (
              <img
                key="coupon-search"
                src={searchIcon}
                alt="select-coupon-template-code"
              />
            ),
            onAction: (e) => {
              handleCouponSearch(e, dspTemplateCode)
            },
          }}
        />
        <ValueChip
          text={couponTitle}
          onClear={handleCouponClear}
          clearLabel={removeCouponLabel}
        />
        {couponError && <div className="error">{couponError}</div>}
      </div>
    </>
  )
}

export default OfferField

export { getCouponTemplateDetails }
